import { render, staticRenderFns } from "./healthManagement.vue?vue&type=template&id=65b41a85&scoped=true"
import script from "./healthManagement.vue?vue&type=script&lang=js"
export * from "./healthManagement.vue?vue&type=script&lang=js"
import style0 from "./healthManagement.vue?vue&type=style&index=0&id=65b41a85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b41a85",
  null
  
)

export default component.exports